export default __webpack_public_path__ + "static/media/chevron-right.9bbe7570.svg";